/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'more': {
    width: 16,
    height: 16,
    viewBox: '0 0 384 384',
    data: '<circle pid="0" cx="192" cy="42.667" r="42.667"/><circle pid="1" cx="192" cy="192" r="42.667"/><circle pid="2" cx="192" cy="341.333" r="42.667"/>'
  }
})
